module.exports = __webpack_public_path__ + "static/media/conferenze-spettacolo.12145410.png";